import React, { useState, useRef } from 'react';
import api from '../api';

const DEMO_QUESTIONS = [
  { id: 1, customer_name: 'Иван', text: 'Подскажите, куртка утеплённая?', answer: 'Да, внутри флисовая подкладка.', created_at: '2025-07-12' },
  { id: 2, customer_name: 'Марина', text: 'Какой длины рукава у размера M?', answer: null, created_at: '2025-07-10' },
  { id: 3, customer_name: 'Алексей', text: 'Есть ли размер XXL?', answer: 'Да, все размеры в наличии.', created_at: '2025-07-05' },
  { id: 4, customer_name: 'Ольга', text: 'Эта модель большемерит?', answer: null, created_at: '2025-06-28' },
];

function QuestionSection({ productId }) {
  const [questions, setQuestions] = useState(DEMO_QUESTIONS);
  const [showForm, setShowForm] = useState(false);
  const [text, setText] = useState('');
  const scrollRef = useRef(null);

  const profile = JSON.parse(localStorage.getItem('customer'));
  const customerName = profile?.name || '';
  const customerPhone = profile?.phone || '';

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 260;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!customerName || !customerPhone) {
      alert('Заполните имя и телефон в профиле');
      return;
    }
    try {
      await api.post(`/api/products/${productId}/questions`, {
        customer_name: customerName,
        customer_phone: customerPhone,
        text,
      });
      setQuestions([
        { id: Date.now(), customer_name: customerName, text, answer: null, created_at: new Date().toISOString() },
        ...questions,
      ]);
      setText('');
      setShowForm(false);
    } catch (err) {
      alert(err.response?.data?.error || 'Ошибка');
    }
  };

  return (
    <div className="questions-block">
      <div className="questions-header">
        <span className="questions-count">{questions.length} вопросов</span>
        <button className="btn btn-outline" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Отмена' : 'Задать вопрос'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="question-form">
          <textarea
            placeholder="Напишите ваш вопрос..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            required
          />
          <button type="submit" className="btn btn-primary">Отправить</button>
        </form>
      )}

      <div className="questions-carousel">
        <button className="scroll-arrow" onClick={() => scroll('left')}>‹</button>
        <div className="questions-scroll-container" ref={scrollRef}>
          {questions.map(q => (
            <div key={q.id} className="question-card">
              <p><strong>{q.customer_name}</strong></p>
              <p>{q.text}</p>
              {q.answer && <p className="answer"><em>Продавец:</em> {q.answer}</p>}
              <small>{new Date(q.created_at).toLocaleDateString()}</small>
            </div>
          ))}
        </div>
        <button className="scroll-arrow" onClick={() => scroll('right')}>›</button>
      </div>
    </div>
  );
}

export default QuestionSection;